import { getFromLocalStorage } from "./localStorageUtils";
export default (graphComponentRef, documentId, onPasteToDocumentGraphData) => {
    if (!graphComponentRef.current)
        return undefined;
    const data = getFromLocalStorage();
    if (!data || !data.FromDocumentId)
        return undefined;
    return () => {
        onPasteToDocumentGraphData({
            ...data,
            ToDocumentId: documentId
        });
    };
};
